// extracted by mini-css-extract-plugin
module.exports = {"btn":"OutOfStockBtn_btn__2SI_S","md":"OutOfStockBtn_md__2y2oT","lg":"OutOfStockBtn_lg__12F19"};